import { useParams } from 'react-router-dom';

import { AppCreatePollPage } from '~/components/pages/AppCreatePollPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppCreatePollRoute: React.FC = () => {
  const { appId } = useParams();
  const navigate = useNavigate();

  if (!appId) {
    navigate('/');

    return null;
  }

  return (
    <DashboardTemplate appId={appId} noAppPreviewOverlap>
      <AppCreatePollPage appId={appId} />
    </DashboardTemplate>
  );
};
